import { Injectable, OnDestroy } from '@angular/core';
import { PortalMessageService } from './portal-message.service';
import { BehaviorSubject, Subscription, delay, map, timer } from 'rxjs';
import { GetPortalMessagesForUserCriteria } from '../models/GetPortalMessagesForUserCriteria';
import { Constants } from 'src/app/shared/model/Constants';

@Injectable({
    providedIn: 'root'
})
export class UserMessagesIndicationService implements  OnDestroy {

    private unreadMessagesSubject = new BehaviorSubject<number>(0);
    unreadMessagesCount = this.unreadMessagesSubject.asObservable();
    private unreadPriorityMessagesSubject = new BehaviorSubject<number>(0);
    unreadPriorityMessagesCount = this.unreadPriorityMessagesSubject.asObservable();
    isLoading: boolean;
    timerSubscription: Subscription; 
    
    constructor(
        private messageService: PortalMessageService
        ) { 

            this.timerSubscription = timer(300000, 300000).pipe( 
                map(() => { 
                  this.refreshData(); 
                }) 
              ).subscribe(); 
        }
    
   
    refreshData() {
        const criteria: GetPortalMessagesForUserCriteria = {
            portalUserId: null,
            pageNumber: 1,
            rowsPerPage: Constants.MaxInt
        };

        this.isLoading = true;
        this.messageService.getPortalMessagesForUser(criteria)
            .subscribe(
                (r) => {
                    this.isLoading = false;
                    const priorityCount = r.filter(m => m.isPriority).length;
                    this.unreadPriorityMessagesSubject.next(priorityCount);
                    this.unreadMessagesSubject.next(r.length - priorityCount);
                }
            )
    }

    ngOnDestroy(): void {
        this.timerSubscription.unsubscribe(); 
    }
}
